import $ from 'jquery'

$(document).ready(equalHeight())

function equalHeight() {
  $('.percent-infographic__element').each(function() {
    let highestBox
    const elementNode = $(this)
      .closest('.row')
      .find('.percent-infographic__title')
    if ($(elementNode).length > 1) {
      highestBox = 0
    }
    $(elementNode).each(function() {
      if ($(this).outerHeight() > highestBox) {
        highestBox = $(this).outerHeight()
      }
    })
    $(elementNode).height(highestBox)
    $(this)
      .find('.percent-infographic__pillar')
      .css('max-height', 'calc(100% - ' + highestBox + 'px)')
  })
}
